'use client';
import React from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import StatsSection from '@/components/StatsSection';
import TrustedBy from '@/components/TrustedBy';
import PlatformSection from '@/components/PlatformSection';
import HybridSection from '@/components/HybridSection';
import CapabilitiesSection from '@/components/CapabilitiesSection';
import SecurityMapSection from '@/components/SecurityMapSection';
import ComplianceSection from '@/components/ComplianceSection';
import IndustriesSection from '@/components/IndustriesSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import RecognitionSection from '@/components/RecognitionSection';
import CTASection from '@/components/CTASection';
import ResourcesSection from '@/components/ResourcesSection';
import Footer from '@/components/Footer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import SocialProofSection from '@/components/SocialProofSection';

export default function HomePage() {
  useScrollAnimation();

  return (
    <div className="min-h-screen bg-[#050a0f] text-[#f5f5f8] noise-overlay-animated">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <TrustedBy />
        <PlatformSection />
        <HybridSection />
        <CapabilitiesSection />
        <SecurityMapSection />
        <ComplianceSection />
        <IndustriesSection />
        <TestimonialsSection />
        <RecognitionSection />
        <SocialProofSection />
        <CTASection />
        <ResourcesSection />
      </main>
      <Footer />
    </div>
  );
}
